import React from "react";
import styles from "./style.module.scss";
import logo from "../../../assets/images/mashie-shield-with-text-white.png";
import { Label } from "semantic-ui-react";
import { Link } from "react-router-dom";
import DeprecatedBanner from "./v2/utils/DeprecatedBanner";
import APIVersionDropdown from "./v2/utils/APIVersionDropdown";

const Endpoint = ({ type, location }) => {
    let colour = "green"; // for GET
    switch (type) {
        case "POST":
            colour = "blue";
            break;
        case "PUT":
            colour = "purple";
            break;
        case "PATCH":
            colour = "yellow";
            break;
        case "DELETE":
            colour = "red";
            break;
        default:
            colour = "green";
    }

    return (
        <h3>
            <Label size='large' color={colour}>
                {type}
            </Label>
            <span className={styles.endpoint}>{location}</span>
        </h3>
    );
};

export default function Index() {
    return (
        <div className='app events' style={{ paddingBottom: "100px" }}>
            <div className={styles.fullHeader} alt='event'>
                <img className={styles.entityLogo} src={logo} alt='logo' />
                <h1 className={styles.headerText}>
                    Golf Course Documentation (v1)
                </h1>
            </div>
            <div className='container'>
                <APIVersionDropdown version='v1' />
                <div className='row mt-5'>
                    <div className='col-12'>
                        <h2>About this API</h2>
                        <p>
                            This API allows you to find golf courses pricing and
                            availability & get quotes for bookings
                        </p>
                    </div>
                </div>
                <div className='row mt-5'>
                    <div className='col-12'>
                        <h2>Endpoints</h2>

                        <Endpoint
                            type='GET'
                            location='/courses/:id/availability'
                        />
                        <p>
                            This endpoint returns potential availability for
                            booking for the given month and year. It will only
                            return days in the future that meet the criteria for
                            booking based on the member passed in and the
                            course's min and max booking times. This is used to
                            display a calendar view for a specific user
                            displaying available days with their AM/PM pricing
                            if booking is allowed / available on those days.
                            Data is not returned for days where booking is not
                            allowed. Data will be returned for days where
                            booking is allowed, whether it be for POA for AM &
                            PM or specific pricing for AM or PM. This is usually
                            shown when in the process of making a booking and
                            real availabiliy data is needed.
                        </p>
                        <h3>Path parameters</h3>
                        <p>
                            <Label>id</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The id of the golf club.
                            </span>
                        </p>
                        <h3>Query parameters</h3>
                        <p>
                            <Label>member</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>The id of the member.</span>
                        </p>
                        <p className='mt-1'>
                            <Label>month</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The month you would like data for. (1 = January)
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>year</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The year you would like data for. (2025)
                            </span>
                        </p>
                        <h3>Response</h3>
                        <Label basic color='green'>
                            200
                        </Label>
                        <span className='ml-2'>OK</span>
                        <pre className={styles.code}>{`{
    "data": [
        {
            "day": 16, 
            "poa": false, 
            "am": null, 
            "pm: 55"
        },
        {
            "day": 20, 
            "poa": false, 
            "am": 97, 
            "pm: 55"
        }
    ]
}`}</pre>

                        <div className={styles.spacer}></div>

                        <Endpoint
                            type='GET'
                            location='/courses/:id/price-list'
                        />
                        <p>
                            This endpoint returns availability for booking for
                            the given month and year. This is used to display a
                            calendar view for a specific user displaying the
                            prices for all days past and future with AM/PM
                            pricing information. This is usually presented when
                            showing the club and course in a general format and
                            no real availability data is needed. We reccomend
                            not allowing the user to look at historic dates,
                            only future. "null" for both AM & PM with a false
                            POA indicates no availability to book.
                        </p>
                        <h3>Path parameters</h3>
                        <p>
                            <Label>id</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The id of the golf club.
                            </span>
                        </p>
                        <h3>Query parameters</h3>
                        <p>
                            <Label>member</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>The id of the member.</span>
                        </p>
                        <p className='mt-1'>
                            <Label>month</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The month you would like data for. (1 = January)
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>year</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The year you would like data for. (2025)
                            </span>
                        </p>
                        <h3>Response</h3>
                        <Label basic color='green'>
                            200
                        </Label>
                        <span className='ml-2'>OK</span>
                        <pre className={styles.code}>{`{
    "data": [
        {
            "day": 1, 
            "poa": false, 
            "am": null, 
            "pm: 55"
        },
        {
            "day": 2, 
            "poa": false, 
            "am": 97, 
            "pm: 55"
        },
        {
            "day": 3, 
            "poa": false, 
            "am": null, 
            "pm: null"
        },
        ...
    ]
}`}</pre>

                        <div className={styles.spacer}></div>

                        <Endpoint type='GET' location='/courses/:id/quote' />
                        <p>
                            This endpoint returns a pricing quote for a tee-time
                            booking at the given course for the given data.
                        </p>
                        <h3>Path parameters</h3>
                        <p>
                            <Label>id</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The id of the golf club.
                            </span>
                        </p>
                        <h3>Query parameters</h3>
                        <p>
                            <Label>member</Label>
                            <Label basic className='ml-1'>
                                String
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>The id of the member.</span>
                        </p>
                        <p className='mt-1'>
                            <Label>hour</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The hour of the day the booking is for. (0-23)
                                This is the start of the booking window. If
                                displayed as 11:00-12:00, send 11.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>day</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The day of the month the booking is for. (1-31)
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>month</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The month of the year the booking is for. (1-12)
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>year</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The year the booking is for. (2025)
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>players</Label>
                            <Label basic className='ml-1'>
                                Int
                            </Label>
                            <Label basic color='red' className='ml-1'>
                                Required
                            </Label>
                            <span className='ml-3'>
                                The number of players the booking is for. (1-8).
                                We reccomend limiting the booking to 4 players
                                for simplicity.
                            </span>
                        </p>
                        <h3>Response</h3>
                        <Label basic color='green'>
                            200
                        </Label>
                        <span className='ml-2'>OK</span>
                        <pre className={styles.code}>{`{
    "data": {
        "poa": false,
        "discountedPricePerPerson": 55,
        "discountedTotal": 110,
        "originalPricePerPerson": 100,
        "originalTotal": 200,
        "discountPercentage": 44,
        "bookingFeePerPerson": 2.75,
        "bookingFeeTotal": 5.5,
        "currency": {
            "_id": "6628e75b5b71a695e65f397f",
            "name": "GBP",
            "symbol": "£"
        }
    }
 }`}</pre>
                        <h3>Additional information</h3>
                        <p>
                            <Label>poa</Label>
                            <Label basic className='ml-1'>
                                Boolean
                            </Label>
                            <span className='ml-3'>
                                If poa is true, then you can display the booking
                                price as "[currency]POA" as one line, but with
                                the booking fee as a second line independently.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>discountedPricePerPerson</Label>
                            <Label basic className='ml-1'>
                                Number / Null
                            </Label>
                            <span className='ml-3'>
                                The price per person that MASHIE will charge
                                each player. Please ensure you use the
                                [currency] when displaying this figure.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>discountedTotal</Label>
                            <Label basic className='ml-1'>
                                Number / Null
                            </Label>
                            <span className='ml-3'>
                                The total price that MASHIE will charge for the
                                green fees. Note, this does not include the
                                booking fees. Please ensure you use the
                                [currency] when displaying this figure.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>originalPricePerPerson</Label>
                            <Label basic className='ml-1'>
                                Number / Null
                            </Label>
                            <span className='ml-3'>
                                The headline price per player for the season the
                                booking is in if booked directly at the club.
                                This can be used to show value by booking with
                                us over direct through the club. Please ensure
                                you use the [currency] when displaying this
                                figure.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>originalTotal</Label>
                            <Label basic className='ml-1'>
                                Number / Null
                            </Label>
                            <span className='ml-3'>
                                The total price for all players for the season
                                the booking is in if booked directly at the
                                club. This can be used to show value by booking
                                with us over direct through the club. Please
                                ensure you use the [currency] when displaying
                                this figure.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>discountPercentage</Label>
                            <Label basic className='ml-1'>
                                Number / Null
                            </Label>
                            <span className='ml-3'>
                                The discount percentage between the club price
                                and our price. This can be used to show value by
                                booking with us over direct through the club.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>bookingFeePerPerson</Label>
                            <Label basic className='ml-1'>
                                Number / Null
                            </Label>
                            <span className='ml-3'>
                                This is the non-refundable booking fee MASHIE
                                charges per player to make the booking. This
                                figure will always be GBP £ regardless of the
                                green fee currency.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>bookingFeeTotal</Label>
                            <Label basic className='ml-1'>
                                Number / Null
                            </Label>
                            <span className='ml-3'>
                                This is the non-refundable total of booking fees
                                MASHIE charges per player to make the booking.
                                This figure will always be GBP £ regardless of
                                the green fee currency.
                            </span>
                        </p>
                        <p className='mt-1'>
                            <Label>currency</Label>
                            <Label basic className='ml-1'>
                                Number / Null
                            </Label>
                            <span className='ml-3'>
                                This is the currency that the green fees will be
                                payable in. This currency can be different to
                                the currency the booking fees are collected in.
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <DeprecatedBanner version='v1' />
        </div>
    );
}
